/* eslint-disable no-empty-pattern */
import kitsu from '@plugins/kitsu';
import http from '@plugins/axios';
import { queryString } from '@utils/format';
let $ajax;

const ENDPOINTS = {
  1: 'kp-lokakarya',
  2: 'pendampingan-lokakarya',
};

export const state = {
  instrumen: null,
};

export const mutations = {
  SET_INSTRUMEN(state, newValue) {
    state.instrumen = newValue;
  },
};

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const angkatan = payload.params.gelombang || 1;
    const tahunKe = payload.params.tahun_ke || 1;

    let endpoint = ENDPOINTS[2];
    if (+angkatan === 1 && +tahunKe === 1) {
      endpoint = ENDPOINTS[1];
    }

    return await http.get(`/psp/i/${id}/${endpoint}?${queryString(payload.params)}`).then(({ data }) => data);
  },

  async getInstrumen({ rootState, commit }, payload) {
    const id = rootState.auth.instansi_id;
    const instrumen = await http
      .get(`/psp/i/${id}/pendampingan-lokakarya/instrumen?master=${payload.masters}`)
      .then(({ data }) => data);

    commit('SET_INSTRUMEN', instrumen);

    return instrumen;
  },

  async getDetail({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`/psp/i/${id}/kp-lokakarya/${payload.id}`).then(({ data }) => data);
  },

  async getDetailPendampingan({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/pendampingan-lokakarya`,
    });
    return await $ajax.get(`/${payload.id}`);
  },

  async getDetailPendampinganLokakarya({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/pendampingan-lokakarya/lokakarya`,
    });
    return await $ajax.get(`/${payload.id}`);
  },

  async getDetailPendampinganRefleksi({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`/psp/i/${id}/pendampingan-lokakarya/refleksi/${payload.id}`).then(({ data }) => data);
  },

  async getSekolah({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`/psp/i/${id}/kp-lokakarya/sekolah?${queryString(payload.params)}`).then(({ data }) => data);
  },

  async getPa({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`/psp/i/${id}/kp-lokakarya/pa?${queryString(payload.params)}`).then(({ data }) => data);
  },

  create({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/kp-lokakarya/create`, payload.params).then(({ data }) => data);
  },

  update({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/kp-lokakarya/${payload.id}/update`, payload.params).then(({ data }) => data);
  },

  delete({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/kp-lokakarya/${payload.id}/delete`).then(({ data }) => data);
  },

  cekRekaman({}, payload) {
    return http.get(`/psp/gtk/kp-lokakarya/cek-rekaman?${queryString(payload)}`).then(({ data }) => data);
  },
};
